export interface ICategory {
  _id?: string;
  name: string;
  createdAt: Date;
  type: ICategoryType;
}

export enum ICategoryType {
  POST = 'post',
}

export interface IGetCategoriesParams {
  type?: ICategoryType;
}
